import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const STRINGS = {
  fr: {
    menu: "Menu",
    cart: "Panier",
    heroTagline: "Pizzeria & cuisine italienne",
    heroKicker: "PIZZERIA · MARLY",
    heroSub: "Pizzas, piadine, pâtes et desserts italiens – à retirer ou en livraison dans la région de Fribourg.",
    orderNowCta: "Commander maintenant",
    howToGet: "Comment souhaitez-vous recevoir votre commande ?",
    pickup: "Retrait",
    delivery: "Livraison",
    pickupInStore: "Retrait sur place",
    modify: "Modifier",
    pickupHint: "Prêt en 15–30 min",
    deliveryHint: "Livraison à domicile",
    all: "Tout",
    loadError: "Impossible de charger le menu",
    retry: "Réessayer",
    emptyCategory: "Aucun produit dans cette catégorie pour le moment",
    closedNow: "Restaurant temporairement fermé",
    pizzaOfMonth: "PIZZA DU MOIS",
    soldOut: "Épuisé",
    from: "dès",
    added: "Ajouté au panier",
    unavailable: "Indisponible",
    back: "Retour",
    origin: "Origine",
    bottle: "Bouteille",
    allergens: "Allergènes",
    notConfigured: "non renseigné",
    size: "Taille",
    dough: "Pâte",
    options: "Options",
    onlyInSizes: "Disponible uniquement en {sizes}",
    removeIngredients: "Retirer des ingrédients",
    removeHint: "Touchez un ingrédient pour le retirer",
    ingredients: "Ingrédients",
    extras: "Suppléments",
    kitchenNote: "Note pour la cuisine",
    kitchenNotePlaceholder: "Ex. bien cuite, sans gluten...",
    quantity: "Quantité",
    total: "Total",
    each: "pièce",
    save: "Enregistrer",
    addToCart: "Ajouter au panier",
    customize: "Personnaliser",
    add: "Ajouter",
    orderNow: "Commander",
    items: "Articles",
    emptyCart: "Votre panier est vide",
    emptyCartHint: "Découvrez nos pizzas et spécialités italiennes.",
    browseMenu: "Voir le menu",
    addMoreProducts: "Ajouter d'autres produits",
    without: "sans",
    orderNote: "Note générale pour la commande",
    orderNotePlaceholder: "Ex. sonner deux fois, sans couverts...",
    subtotal: "Sous-total produits",
    extrasTotal: "Suppléments",
    deliveryFee: "Frais de livraison",
    free: "Gratuit",
    noOnlinePayment: "Aucun paiement en ligne. Vous payez en espèces ou par carte sur place.",
    checkout: "Commander",
    account: "Mon compte",
    login: "Se connecter",
    logout: "Se déconnecter",
    password: "Mot de passe",
    guestHint: "Compte facultatif – vous pouvez toujours consulter le menu sans compte.",
    loggedInAs: "Connecté en tant que",
    welcome: "Bienvenue",
    profile: "Profil",
    savedAddresses: "Adresses enregistrées",
    noAddresses: "Aucune adresse enregistrée",
    orderHistory: "Historique des commandes",
    noHistory: "Aucune commande pour le moment",
    phone: "Téléphone",
    loginError: "Téléphone ou mot de passe incorrect",
    required: "Champs obligatoires manquants",
    yourDetails: "Vos coordonnées",
    firstName: "Prénom",
    lastName: "Nom",
    email: "E-mail",
    invalidEmail: "Adresse e-mail invalide",
    emailUsage: "Utilisé pour le suivi de votre commande et une éventuelle demande d'avis après la livraison.",
    street: "Rue",
    number: "N°",
    npa: "NPA",
    city: "Ville",
    deliveryInstructions: "Instructions de livraison",
    useSavedAddress: "Utiliser une adresse enregistrée",
    newAddress: "Nouvelle adresse",
    desiredTime: "Heure souhaitée",
    asap: "Dès que possible",
    chooseTime: "Choisir une heure",
    today: "Aujourd'hui",
    tomorrow: "Demain",
    restaurantClosed: "Restaurant fermé",
    noExactSlotsAsap: "Plus d'horaire précis disponible pour aujourd'hui. Choisissez « Dès que possible ».",
    noExactSlots: "Aucun horaire précis disponible pour le moment.",
    nextOpening: "Prochaine ouverture",
    earliestDelivery: "Première livraison",
    deliveryUnavailable: "Livraison indisponible pour le moment – retrait possible jusqu'à la fermeture",
    asapFromOpening: "Restaurant fermé pour l'instant – « Dès que possible » = première heure disponible après l'ouverture à",
    scheduledFor: "Commande programmée pour",
    notGuaranteed: "L'heure choisie sera confirmée par le restaurant.",
    closedToday: "Restaurant fermé aujourd'hui. Les commandes seront de nouveau disponibles à la prochaine ouverture.",
    closedTodayShort: "Fermé aujourd'hui",
    loyaltyTitle: "Carte Fidélité",
    loyaltyRewardAvailable: "Récompense disponible",
    loyaltyGuestHint: "Connectez-vous pour cumuler votre Carte Fidélité – 50% sur une pizza 32 cm toutes les 10 étampes.",
    loyaltyStampsLabel: "étampes",
    loyaltyStampsRule: "32 & 40 cm = 1 étampe · 50 cm = 2 · Calzone = 1 · Bambino = 0",
    loyaltyEarn: "avec cette commande",
    loyaltyRewardApplied: "Récompense appliquée — 50% sur votre pizza 32 cm.",
    loyaltyRewardKept: "Récompense conservée — ajoutez une pizza 32 cm pour profiter du −50%.",
    howToPay: "Comment souhaitez-vous payer ?",
    payCash: "Espèces",
    payCard: "Carte (terminal)",
    payAtPickup: "Paiement au retrait",
    payAtDelivery: "Paiement à la livraison",
    confirmOrder: "Confirmer la commande",
    minOrder: "Minimum de commande pour la livraison",
    zoneNotServed: "Zone de livraison non desservie",
    ageConfirm16: "Je confirme avoir 16 ans ou plus (bière, vin, prosecco)",
    ageConfirm18: "Je confirme avoir 18 ans ou plus (spiritueux)",
    ageRequired: "Veuillez confirmer votre âge pour les boissons alcoolisées.",
    myOrders: "Mes commandes",
    readyAround: "prête vers",
    deliveryAround: "livraison vers",
    orderingDisabled: "Aperçu uniquement — la finalisation de commande n'est pas encore activée.",
    orderingUnavailableTitle: "Commande en ligne temporairement indisponible",
    orderingUnavailableBody: "La commande en ligne est momentanément désactivée. Pour commander, merci d'utiliser l'application ou d'appeler directement le restaurant. Le menu reste consultable ici.",
    loginToOrder: "Connectez-vous à votre compte existant pour préremplir vos informations.",
    register: "Créer un compte",
    edit: "Modifier",
    close: "Fermer",
    saved: "Enregistré",
    addAddress: "Ajouter une adresse",
    editAddress: "Modifier l'adresse",
    addressLabel: "Nom (ex. Maison, Bureau)",
    passwordHint: "6 caractères minimum",
    noAccountYet: "Pas encore de compte ?",
    alreadyAccount: "Déjà un compte ?",
    confirmDelete: "Confirmer la suppression ?",
    cancel: "Annuler",
    marketingConsent: "Je souhaite recevoir les offres, nouveautés et promotions de Hallo Magic Pizza par e-mail. Je peux me désinscrire à tout moment.",
    marketingTitle: "Offres & nouveautés par e-mail",
    marketingOn: "Inscription aux offres enregistrée",
    marketingOff: "Désinscription enregistrée",
    saveThisAddress: "Enregistrer cette adresse dans mon profil",
    orderPlaced: "Commande envoyée !",
    orderReceived: "Commande reçue",
    viewMyOrder: "Voir ma commande",
    orderSentRecovery: "Votre commande a bien été envoyée. Inutile de la renvoyer — ouvrez-la ci-dessous.",
    orderNumber: "Commande",
    estimatedTime: "Heure estimée",
    trackOrder: "Suivre ma commande",
    yourOrder: "Votre commande",
    orderConfirmedThanks: "Merci ! Votre commande a bien été transmise au restaurant.",
    networkUncertain: "Impossible de confirmer si la commande a été créée. NE renvoyez PAS la commande — vérifiez d'abord « Mes commandes » ou appelez le restaurant.",
    checkHistory: "Voir mes commandes",
    paymentAtHandover: "Paiement sur place",
    legalPrivacy: "Confidentialité",
    legalTerms: "CGV",
    legalImprint: "Mentions légales",
    staffAccess: "Accès restaurant",
    staffHint: "Réservé au personnel. Saisissez votre code Manager / Staff.",
    staffPin: "Code / mot de passe",
    staffConnected: "Connecté",
    staffSessionUntil: "Session valable jusqu'au",
    staffScreensSoon: "Les écrans du Manager seront ajoutés prochainement.",
    staffLoginError: "Code incorrect",
    estReady: "Prête vers",
    estDelivery: "Livraison estimée vers",
    legalPlaceholder: "Ce texte n'a pas encore été renseigné par le restaurant.",
    status_pending: "En attente de confirmation",
    status_accepted: "Acceptée",
    status_preparing: "En préparation",
    status_ready_pickup: "Prête à retirer",
    status_ready_delivery: "Prête pour livraison",
    status_picked_up: "Retirée",
    status_assigned: "Attribuée au livreur",
    status_delivering: "En livraison",
    status_delivered: "Livrée",
    status_completed: "Terminée",
    status_cancelled: "Annulée",
  },
  de: {
    menu: "Menü",
    cart: "Warenkorb",
    heroTagline: "Pizzeria & italienische Küche",
    heroKicker: "PIZZERIA · MARLY",
    heroSub: "Pizzas, Piadine, Pasta und italienische Desserts – zum Abholen oder geliefert in der Region Freiburg.",
    orderNowCta: "Jetzt bestellen",
    howToGet: "Wie möchten Sie Ihre Bestellung erhalten?",
    pickup: "Abholung",
    delivery: "Lieferung",
    pickupInStore: "Abholung vor Ort",
    modify: "Ändern",
    pickupHint: "Bereit in 15–30 Min.",
    deliveryHint: "Lieferung nach Hause",
    all: "Alle",
    loadError: "Menü konnte nicht geladen werden",
    retry: "Erneut versuchen",
    emptyCategory: "Noch keine Produkte in dieser Kategorie",
    closedNow: "Restaurant vorübergehend geschlossen",
    pizzaOfMonth: "MONATSPIZZA",
    soldOut: "Ausverkauft",
    from: "ab",
    added: "Zum Warenkorb hinzugefügt",
    unavailable: "Nicht verfügbar",
    back: "Zurück",
    origin: "Herkunft",
    bottle: "Flasche",
    allergens: "Allergene",
    notConfigured: "nicht erfasst",
    size: "Grösse",
    dough: "Teig",
    options: "Optionen",
    onlyInSizes: "Nur in {sizes} erhältlich",
    removeIngredients: "Zutaten entfernen",
    removeHint: "Tippen Sie auf eine Zutat, um sie zu entfernen",
    ingredients: "Zutaten",
    extras: "Extras",
    kitchenNote: "Notiz für die Küche",
    kitchenNotePlaceholder: "z.B. gut durchgebacken, glutenfrei...",
    quantity: "Menge",
    total: "Total",
    each: "Stück",
    save: "Speichern",
    addToCart: "In den Warenkorb",
    customize: "Anpassen",
    add: "Hinzufügen",
    orderNow: "Bestellen",
    items: "Artikel",
    emptyCart: "Ihr Warenkorb ist leer",
    emptyCartHint: "Entdecken Sie unsere Pizzas und italienischen Spezialitäten.",
    browseMenu: "Zum Menü",
    addMoreProducts: "Weitere Produkte hinzufügen",
    without: "ohne",
    orderNote: "Allgemeine Notiz zur Bestellung",
    orderNotePlaceholder: "z.B. zweimal klingeln, kein Besteck...",
    subtotal: "Zwischensumme Produkte",
    extrasTotal: "Extras",
    deliveryFee: "Liefergebühr",
    free: "Gratis",
    noOnlinePayment: "Keine Online-Zahlung. Sie bezahlen bar oder mit Karte vor Ort.",
    checkout: "Bestellen",
    account: "Mein Konto",
    login: "Anmelden",
    logout: "Abmelden",
    password: "Passwort",
    guestHint: "Konto optional – Sie können das Menü auch ohne Konto ansehen.",
    loggedInAs: "Angemeldet als",
    welcome: "Willkommen",
    profile: "Profil",
    savedAddresses: "Gespeicherte Adressen",
    noAddresses: "Keine gespeicherte Adresse",
    orderHistory: "Bestellverlauf",
    noHistory: "Noch keine Bestellungen",
    phone: "Telefon",
    loginError: "Telefon oder Passwort ist falsch",
    required: "Pflichtfelder fehlen",
    yourDetails: "Ihre Angaben",
    firstName: "Vorname",
    lastName: "Nachname",
    email: "E-Mail",
    invalidEmail: "Ungültige E-Mail-Adresse",
    emailUsage: "Für die Bestellbestätigung und eine mögliche Bewertungsanfrage nach der Lieferung.",
    street: "Strasse",
    number: "Nr.",
    npa: "PLZ",
    city: "Ort",
    deliveryInstructions: "Lieferhinweise",
    useSavedAddress: "Gespeicherte Adresse verwenden",
    newAddress: "Neue Adresse",
    desiredTime: "Wunschzeit",
    asap: "So schnell wie möglich",
    chooseTime: "Uhrzeit wählen",
    today: "Heute",
    tomorrow: "Morgen",
    restaurantClosed: "Restaurant geschlossen",
    noExactSlotsAsap: "Für heute ist keine genaue Uhrzeit mehr verfügbar. Wählen Sie «So schnell wie möglich».",
    noExactSlots: "Zurzeit ist keine genaue Uhrzeit verfügbar.",
    nextOpening: "Nächste Öffnung",
    earliestDelivery: "Erste Lieferung",
    deliveryUnavailable: "Lieferung derzeit nicht verfügbar – Abholung bis Ladenschluss möglich",
    asapFromOpening: "Zurzeit geschlossen – «So schnell wie möglich» = erste verfügbare Zeit nach der Öffnung um",
    scheduledFor: "Vorbestellung für",
    notGuaranteed: "Die gewählte Zeit wird vom Restaurant bestätigt.",
    closedToday: "Restaurant heute geschlossen. Bestellungen sind ab der nächsten Öffnung wieder möglich.",
    closedTodayShort: "Heute geschlossen",
    loyaltyTitle: "Treuekarte",
    loyaltyRewardAvailable: "Prämie verfügbar",
    loyaltyGuestHint: "Melden Sie sich an und sammeln Sie Treuepunkte – 50% auf eine 32-cm-Pizza pro 10 Stempel.",
    loyaltyStampsLabel: "Stempel",
    loyaltyStampsRule: "32 & 40 cm = 1 Stempel · 50 cm = 2 · Calzone = 1 · Bambino = 0",
    loyaltyEarn: "mit dieser Bestellung",
    loyaltyRewardApplied: "Prämie angewendet — 50% auf Ihre 32-cm-Pizza.",
    loyaltyRewardKept: "Prämie behalten — fügen Sie eine 32-cm-Pizza hinzu, um den −50%-Rabatt zu nutzen.",
    howToPay: "Wie möchten Sie bezahlen?",
    payCash: "Bar",
    payCard: "Karte (Terminal)",
    payAtPickup: "Zahlung bei Abholung",
    payAtDelivery: "Zahlung bei Lieferung",
    confirmOrder: "Bestellung bestätigen",
    minOrder: "Mindestbestellwert für Lieferung",
    zoneNotServed: "Liefergebiet nicht bedient",
    ageConfirm16: "Ich bestätige, dass ich 16 Jahre oder älter bin (Bier, Wein, Prosecco)",
    ageConfirm18: "Ich bestätige, dass ich 18 Jahre oder älter bin (Spirituosen)",
    ageRequired: "Bitte bestätigen Sie Ihr Alter für alkoholische Getränke.",
    myOrders: "Meine Bestellungen",
    readyAround: "bereit gegen",
    deliveryAround: "Lieferung gegen",
    orderingDisabled: "Nur Vorschau — der Bestellabschluss ist noch nicht aktiviert.",
    orderingUnavailableTitle: "Online-Bestellung vorübergehend nicht verfügbar",
    orderingUnavailableBody: "Die Online-Bestellung ist derzeit deaktiviert. Bitte bestellen Sie über die App oder rufen Sie das Restaurant direkt an. Das Menü können Sie hier weiterhin ansehen.",
    loginToOrder: "Melden Sie sich mit Ihrem bestehenden Konto an, um Ihre Angaben vorauszufüllen.",
    register: "Konto erstellen",
    edit: "Bearbeiten",
    close: "Schliessen",
    saved: "Gespeichert",
    addAddress: "Adresse hinzufügen",
    editAddress: "Adresse bearbeiten",
    addressLabel: "Name (z.B. Zuhause, Büro)",
    passwordHint: "Mindestens 6 Zeichen",
    noAccountYet: "Noch kein Konto?",
    alreadyAccount: "Bereits ein Konto?",
    confirmDelete: "Löschen bestätigen?",
    cancel: "Abbrechen",
    marketingConsent: "Ich möchte Angebote, Neuigkeiten und Aktionen von Hallo Magic Pizza per E-Mail erhalten. Ich kann mich jederzeit abmelden.",
    marketingTitle: "Angebote & Neuigkeiten per E-Mail",
    marketingOn: "Anmeldung für Angebote gespeichert",
    marketingOff: "Abmeldung gespeichert",
    saveThisAddress: "Diese Adresse in meinem Profil speichern",
    orderPlaced: "Bestellung gesendet!",
    orderReceived: "Bestellung erhalten",
    viewMyOrder: "Meine Bestellung ansehen",
    orderSentRecovery: "Ihre Bestellung wurde erfolgreich gesendet. Kein erneutes Senden nötig — unten öffnen.",
    orderNumber: "Bestellung",
    estimatedTime: "Geschätzte Zeit",
    trackOrder: "Bestellung verfolgen",
    yourOrder: "Ihre Bestellung",
    orderConfirmedThanks: "Danke! Ihre Bestellung wurde an das Restaurant übermittelt.",
    networkUncertain: "Es konnte nicht bestätigt werden, ob die Bestellung erstellt wurde. Bitte NICHT erneut senden — prüfen Sie zuerst «Meine Bestellungen» oder rufen Sie das Restaurant an.",
    checkHistory: "Meine Bestellungen ansehen",
    paymentAtHandover: "Zahlung vor Ort",
    legalPrivacy: "Datenschutz",
    legalTerms: "AGB",
    legalImprint: "Impressum",
    staffAccess: "Restaurant-Zugang",
    staffHint: "Nur für Personal. Geben Sie Ihren Manager-/Staff-Code ein.",
    staffPin: "Code / Passwort",
    staffConnected: "Angemeldet",
    staffSessionUntil: "Sitzung gültig bis",
    staffScreensSoon: "Die Manager-Ansichten werden in Kürze hinzugefügt.",
    staffLoginError: "Falscher Code",
    estReady: "Bereit gegen",
    estDelivery: "Lieferung ca. um",
    legalPlaceholder: "Dieser Text wurde vom Restaurant noch nicht hinterlegt.",
    status_pending: "Warten auf Bestätigung",
    status_accepted: "Angenommen",
    status_preparing: "In Zubereitung",
    status_ready_pickup: "Abholbereit",
    status_ready_delivery: "Bereit zur Lieferung",
    status_picked_up: "Abgeholt",
    status_assigned: "Kurier zugewiesen",
    status_delivering: "Unterwegs",
    status_delivered: "Geliefert",
    status_completed: "Abgeschlossen",
    status_cancelled: "Storniert",
  },
};

const Ctx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = typeof localStorage !== "undefined" ? localStorage.getItem("lang") : null;
    return saved === "de" ? "de" : "fr";
  });
  useEffect(() => {
    try { localStorage.setItem("lang", lang); } catch {}
  }, [lang]);
  const setLang = useCallback((l) => setLangState(l), []);
  const value = useMemo(() => ({
    lang,
    setLang,
    t: (key) => STRINGS[lang][key] ?? key,
    tx: (obj) => (obj ? obj[lang] ?? obj.fr ?? "" : ""),
  }), [lang, setLang]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useI18n() {
  const c = useContext(Ctx);
  if (!c) throw new Error("I18nProvider missing");
  return c;
}

export function statusLabel(status, type, t) {
  if (status === "ready") return type === "pickup" ? t("status_ready_pickup") : t("status_ready_delivery");
  return t(`status_${status}`);
}
